// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import { bulma } from "bulma";
import "./scss/application.scss";
require("@rails/ujs").start();
import "@hotwired/turbo-rails"
require("@rails/activestorage").start();
require("channels");
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");


ReactRailsUJS.useContext(componentRequireContext);

// react_ujs 2.7.x predates Hotwire — it only knows Turbolinks / pjax / DOMContentLoaded.
// With Turbo Drive, navigations don't fire DOMContentLoaded, so React components
// mount only on full page reloads. Wire it to Turbo events explicitly.
document.addEventListener('turbo:load', () => ReactRailsUJS.mountComponents());
document.addEventListener('turbo:before-render', () => ReactRailsUJS.unmountComponents());
document.addEventListener('turbo:frame-load', (event) => ReactRailsUJS.mountComponents(event.target));

const range = (start, stop) => Array.from({ length: stop - start + 1 }, (_, i) => start + i)

// Document-level delegated handlers for elements that live INSIDE a turbo frame
// (currently :leads_table). These need delegation because Turbo Frame swaps
// replace the DOM elements without firing turbo:load, so per-element handlers
// bound inside turbo:load would only attach on first page load.
//
// Bound ONCE here (not inside turbo:load) so they don't stack on each navigation.

$(document).on('change', '.update_stages', function () {
    const $select = $(this);
    const lead_id = $select.data('lead-id');
    const newStage = $select.val();
    const oldStage = $select.data('old-stage');

    $.ajax({
        type: "POST",
        url: "/leads/update_stage",
        data: { lead: { id: lead_id, business_stage: newStage } },
        success: function () { console.log('updated'); },
        error: function () { console.log('failure'); $select.val(oldStage); }
    });
});

$(document).on('touch click', '.ratings .rating', function () {
    const $this = $(this);
    const rating = $this.data('rating');
    const lead_id = $this.data('lead-id');

    range(1, rating).forEach((item) => {
        const d = $this.parent().find('*[data-rating="' + item + '"]');
        if (!d.hasClass('has-rating')) {
            d.removeClass('notfilled').addClass('filled has-rating');
        }
    });

    if ($this.hasClass('has-rating')) {
        range(rating + 1, 5).forEach((item) => {
            $this.parent().find('*[data-rating="' + item + '"]').removeClass('filled').addClass('notfilled');
        });
    }

    $.ajax({
        type: "POST",
        url: "/leads/update_rating",
        data: { id: lead_id, rating: rating },
        success: function (data) { console.log('success', data); },
        error: function () { console.log('failure'); }
    });
});

$(document).on('mouseover', '.ratings .rating', function () {
    const $this = $(this);
    const rating = $this.data('rating');
    range(1, rating).forEach((item) => {
        const d = $this.parent().find('*[data-rating="' + item + '"]');
        if (!d.hasClass('has-rating')) d.removeClass('notfilled').addClass('filled');
    });
    if ($this.hasClass('has-rating')) {
        range(rating + 1, 5).forEach((item) => {
            $this.parent().find('*[data-rating="' + item + '"]').removeClass('filled').addClass('notfilled');
        });
    }
});

$(document).on('mouseout', '.ratings .rating', function () {
    const $this = $(this);
    const rating = $this.data('rating');
    range(1, rating).forEach((item) => {
        const d = $this.parent().find('*[data-rating="' + item + '"]');
        if (d.hasClass('has-rating')) {
            d.removeClass('notfilled').addClass('filled');
        } else {
            d.removeClass('filled').addClass('notfilled');
        }
    });
});

// .rating-icon (tooltip info icon in the leads table header) lives inside :leads_table
// and gets re-rendered on every filter swap.
$(document).on('touch click', '.rating-icon', function () {
    $('.tooltip').toggle();
});

// .toggler — notification group expander — lives inside :notifications_panel
// and gets re-rendered on every broadcast.
$(document).on('touch click', '.toggler', function () {
    const toggle = '#list-' + $(this).data('toggler');
    $(this).find('svg').toggleClass('fa-chevron-down fa-chevron-up');
    $(toggle).toggleClass('active');
});

// Header "select all" checkbox toggles row checkboxes — both live inside the frame.
$(document).on('change', '.select-all', function () {
    $('.lead_ids input[type="checkbox"]').prop('checked', this.checked);
    updateSelectedCount();
});

// Row checkbox click updates the visible counter.
$(document).on('click', '.lead_ids input[type="checkbox"]', updateSelectedCount);

function updateSelectedCount() {
    const counter = document.getElementById('boxesChecked');
    if (!counter) return;
    counter.innerHTML = $('.lead_ids input[type="checkbox"]:checked').length;
}

$(document).on('turbo:load', function() {

    $('.submit-custom-label').on('touch click', function() {

        const parentDiv = $(this).parent();
        const lead_id = parentDiv.find('input[name="lead_id"]').val();
        const name = parentDiv.find('input[name="name"]').val();
        if(name == "" || lead_id == ""){
            return false;
        }

        $.ajax({
            type: "POST",
            url: "/labels/create",
            data: {label: {lead_id: lead_id, name: name}},
            success: function (data, textStatus, jqXHR) {
                parentDiv.classList.remove('is-active')
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log('failure')
            }
        })
    });

    (document.querySelectorAll('.open-label-modal') || []).forEach(($trigger) => {
        const modal = $trigger.dataset.target;
        const $target = document.getElementById(modal);

        console.log($target)


        $trigger.addEventListener('click', () => {
            openLabelModal($target);
        });
    });

    // .update_stages handler is registered at document level (outside turbo:load)
    // because the dropdowns live inside the :leads_table turbo frame and get
    // re-rendered on every filter/search/paginate swap.

    function openLabelModal($el){
        console.log($el);
        $el.classList.add('is-active');
    }

    // Functions to open and close a modal
    function openModal($el) {
        $el.classList.add('is-active');
    }

    function closeModal($el) {
        $el.classList.remove('is-active');
    }

    function closeAllModals() {
        (document.querySelectorAll('.modal') || []).forEach(($modal) => {
            closeModal($modal);
        });
    }

    // Add a click event on buttons to open a specific modal
    (document.querySelectorAll('.js-modal-trigger') || []).forEach(($trigger) => {
        const modal = $trigger.dataset.target;
        const $target = document.getElementById(modal);

        $trigger.addEventListener('click', () => {
            openModal($target);
        });
    });

    // Add a click event on various child elements to close the parent modal
    (document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button') || []).forEach(($close) => {
        const $target = $close.closest('.modal');

        $close.addEventListener('click', () => {
            closeModal($target);
        });
    });

    // Add a keyboard event to close all modals
    document.addEventListener('keydown', (event) => {
        const e = event || window.event;

        if (e.keyCode === 27) { // Escape key
            closeAllModals();
        }
    });

    $('.close-tooltip').on('touch click', function(){
        $('.tooltip').hide();
    })

    $('.ratings-filter .rating').on('touch click', function() {
        var rating = $(this).data('rating');
        $('.rating-form-field').val(rating);
    });
    // .rating-icon handler moved to document-level delegation (see top of file).


    // .ratings .rating click/mouseover/mouseout handlers are registered at
    // document level (outside turbo:load) — the stars live inside the
    // :leads_table turbo frame and get re-rendered on every filter swap.


    $('.open-notifications-center').on('touch click', function() {
        $('.notification-center').toggleClass('active');
        $('.notification-center').toggle();
        $('.overlay').toggleClass('active')
    });

    // .toggler handler moved to document-level delegation (see top of file).

    $('.overlay').on('touch click', function() {
        if($('.notification-center').hasClass('active')) {

            $('.notification-center').toggleClass('active');
            $('.notification-center').toggle();
            $('.overlay').toggleClass('active')
        }
    })

    $('input[name="delete"]').val(false);

    $('#deleteButton').on('touch click', function(){
        $('input[name="delete"]').val(true);
    });

    $('#autoAssignButton').on('touch click', function(){
        $('input[name="autoassign"]').val(true);
    });
    $('#open-search').on('touch click', function(){
        $('#filter-form').hide();
        $('#form-update').hide();
        $('#search-form').toggle();
    });
    $('#open-filter').on('touch click', function(){
        $('#filter-form').toggle();
        $('#form-update').hide();
        $('#search-form').hide();
    });
    $('#open-update').on('touch click', function(){
        $('#filter-form').hide();
        $('#search-form').hide();


        $('#form-update').toggle();
    });

    // Selection counter is initialised here so it resets to 0 on each navigation.
    // The actual click/change handlers for .select-all and .lead_ids checkboxes
    // are delegated at document level (see top of file) so they survive
    // turbo:frame-load swaps of the leads table.
    const initialCounter = document.getElementById('boxesChecked');
    if (initialCounter) initialCounter.innerHTML = 0;

});
require("trix")
require("@rails/actiontext")